import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Container from "@material-ui/core/Container";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { Link } from "@material-ui/core";
// import Button from "@material-ui/core/Button";

import useStyleNavbar from "../styles/useStyleNavbar";


const Navbar = () => {
  const classes = useStyleNavbar();
  return (
    <div>
      <AppBar className={classes.appBar} position="static" elevation={0}>
        <Toolbar>
          <Container maxWidth="lg">
            <Typography variant="h6" className={classes.headText}>
              <Link href={window.location.origin + process.env.PUBLIC_URL} color="textPrimary" underline="none">
                DiDA - Ricerche
              </Link>
              {/* <Button href="Admin" color="primary">
                Admin
              </Button> */}
            </Typography>
          </Container>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Navbar;
